import { Upload } from 'lucide-react';
import { ImportBoardTemplateTarget } from 'modules/core/domain/interfaces/supabase/overlay/auxiliary-types';
import { useImportBoardTemplate } from 'modules/template-editor/ui/hooks/use-import-board-template';
import { ReactNode } from 'react';
import UDButton from 'ud-ui/components/button';
import UDTippy from 'ud-ui/components/tippy';

interface ImportBoardTemplateButtonProps {
  /** Куда создаётся шаблон: своя организация или общие «готовые»; `null` — некуда, кнопка выключена. */
  target: ImportBoardTemplateTarget | null;
  /** Подпись кнопки. */
  children: ReactNode;
  /** Импорт создаёт шаблон — в списке организации заперт там же, где «Добавить шаблон». */
  disabled?: boolean;
  /** Подсказка выключенной кнопки («Не доступно в вашей подписке»). */
  lockedTooltip?: string;
}

/**
 * Импорт шаблона трансляции из файла (IMGM-1589): «Импортировать шаблон» в шапке списка организации и
 * «Импортировать из файла» супер-админа в каталоге «Готовые шаблоны».
 */
function ImportBoardTemplateButton({ target, children, disabled = false, lockedTooltip }: ImportBoardTemplateButtonProps) {
  const { isImporting, pickFile, fileInput } = useImportBoardTemplate(target);

  return (
    <>
      <UDTippy content={lockedTooltip} placement={'bottom'}>
        <span className="inline-flex">
          <UDButton
            variant={'dark'}
            className="flex items-center"
            onClick={pickFile}
            loading={isImporting}
            disabled={disabled || !target}
          >
            <Upload size={16} className="mr-2" />
            {children}
          </UDButton>
        </span>
      </UDTippy>
      {fileInput}
    </>
  );
}

export default ImportBoardTemplateButton;
